import Application from "../../Application";
import Area, { IArea } from "../../core/areas/Area";
import { IRouter } from "../../runtime/Router";
import CreateLegalViewInteractor from "../interactor/CreateLegalViewInteractor";
import CreateLegalViewTypeInteractor from "../interactor/CreateLegalViewTypeInteractor";
import FindLegalViewInteractor from "../interactor/FindLegalViewInteractor";
import GetAllLegalViewsInteractor from "../interactor/GetAllLegalViewsInteractor";
import GetAllLegalViewTypesInteractor from "../interactor/GetAllLegalViewTypesInteractor";
import GetLegalViewIndexesInteractor from "../interactor/GetLegalViewIndexesInteractor";
import GetLegalViewTypeIndexDataInteractor from "../interactor/GetLegalViewTypeIndexDataInteractor";
import ShowLegalViewCreationInteractor from "../interactor/ShowLegalViewCreationInteractor";
import ShowLegalViewDetailsInteractor from "../interactor/ShowLegalViewDetailsInteractor";
import ShowLegalViewInteractor from "../interactor/ShowLegalViewInteractor";
import ShowLegalViewTypesInteractor from "../interactor/ShowLegalViewTypesInteractor";
import ShowLegalViewUpdateInteractor from "../interactor/ShowLegalViewUpdateInteractor";
import UpdateLegalViewInteractor from "../interactor/UpdateLegalViewInteractor";
import UpdateLegalViewTypeInteractor from "../interactor/UpdateLegalViewTypeInteractor";
import GetAttachmentsForLegalViewsInteractor from "../interactor/GetAttachmentsForLegalViewsInteractor";
import CreateLegalViewAttachmentInteractor from "../interactor/CreateLegalViewAttachmentInteractor";
import LegalViewCreationPage from "../ui/pages/LegalViewCreationPage";
import LegalViewDetailsPage from "../ui/pages/LegalViewDetailsPage";
import LegalViewPage from "../ui/pages/LegalViewPage";
import LegalViewTypesPage from "../ui/pages/LegalViewTypesPage";
import LegalViewUpdatePage from "../ui/pages/LegalViewUpdatePage";
import FindLegalViewIndexesInCategoryInteractor from "../interactor/FindLegalViewIndexesInCategoryInteractor";
import PublishLegalViewInteractor from "../interactor/PublishLegalViewInteractor";
import ArchiveLegalViewInteractor from "../interactor/ArchiveLegalViewInteractor";
import RevertLegalViewStatusInteractor from "../interactor/RevertLegalViewStatusInteractor";
import DeleteLegalViewInteractor from "../interactor/DeleteLegalViewInteractor";

export default class LegalViewArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;
    container.registerInteractor("showLegalViews", ShowLegalViewInteractor);
    container.registerInteractor(
      "showLegalViewTypes",
      ShowLegalViewTypesInteractor
    );
    container.registerInteractor(
      "getAllLegalViewTypes",
      GetAllLegalViewTypesInteractor
    );
    container.registerInteractor(
      "createLegalViewType",
      CreateLegalViewTypeInteractor
    );
    container.registerInteractor(
      "updateLegalViewType",
      UpdateLegalViewTypeInteractor
    );
    container.registerInteractor(
      "getAllLegalViews",
      GetAllLegalViewsInteractor
    );
    container.registerInteractor(
      "getLegalViewTypeIndexData",
      GetLegalViewTypeIndexDataInteractor
    );
    container.registerInteractor("createLegalView", CreateLegalViewInteractor);
    container.registerInteractor(
      "showLegalViewCreation",
      ShowLegalViewCreationInteractor
    );
    container.registerInteractor(
      "showLegalViewDetails",
      ShowLegalViewDetailsInteractor
    );
    container.registerInteractor("findLegalView", FindLegalViewInteractor);
    container.registerInteractor(
      "getLegalViewIndexes",
      GetLegalViewIndexesInteractor
    );
    container.registerInteractor("updateLegalView", UpdateLegalViewInteractor);
    container.registerInteractor(
      "showLegalViewUpdate",
      ShowLegalViewUpdateInteractor
    );
    container.registerInteractor(
      "getAttachmentsForLegalViews",
      GetAttachmentsForLegalViewsInteractor
    );
    container.registerInteractor(
      "createLegalViewAttachment",
      CreateLegalViewAttachmentInteractor
    );
    container.registerInteractor(
      "findLegalViewIndexesInCategory",
      FindLegalViewIndexesInCategoryInteractor
    );
    container.registerInteractor(
      "publishLegalView",
      PublishLegalViewInteractor
    );
    container.registerInteractor(
      "archiveLegalView",
      ArchiveLegalViewInteractor
    );
    container.registerInteractor(
      "revertLegalViewStatus",
      RevertLegalViewStatusInteractor
    );
    container.registerInteractor("deleteLegalView", DeleteLegalViewInteractor);
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes(
      {
        path: "/legal-views",
        page: this.createPage({
          Page: LegalViewPage,
          action: this.showLegalViewPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/legal-views/new",
        page: this.createPage({
          Page: LegalViewCreationPage,
          action: this.showLegalViewCreationPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/legal-views/:id/details",
        page: this.createPage({
          Page: LegalViewDetailsPage,
          action: this.showLegalViewDetailsPage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/legal-views/:id/update",
        page: this.createPage({
          Page: LegalViewUpdatePage,
          action: this.showLegalViewUpdatePage.bind(this)
        }),
        options: {
          secure: true
        }
      },
      {
        path: "/legal-view-types",
        page: this.createPage({
          Page: LegalViewTypesPage,
          action: this.showLegalViewTypesPage.bind(this)
        }),
        options: {
          secure: true
        }
      }
    );
  }

  public showLegalViewPage() {
    return this.application.container
      .resolve<ShowLegalViewInteractor>("showLegalViews")
      .execute();
  }
  public showLegalViewTypesPage() {
    return this.application.container
      .resolve<ShowLegalViewTypesInteractor>("showLegalViewTypes")
      .execute();
  }
  public showLegalViewCreationPage() {
    return this.application.container
      .resolve<ShowLegalViewCreationInteractor>("showLegalViewCreation")
      .execute();
  }
  public showLegalViewDetailsPage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowLegalViewDetailsInteractor>("showLegalViewDetails")
      .execute(Number.parseInt(id, 10));
  }
  public showLegalViewUpdatePage({ id }: { id: string }) {
    return this.application.container
      .resolve<ShowLegalViewUpdateInteractor>("showLegalViewUpdate")
      .execute(Number.parseInt(id, 10));
  }
}
